"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _StepCompletionNotif = _interopRequireDefault(require("../../components/Modals/StepCompletionNotif"));
var _Bubble = _interopRequireDefault(require("../../components/Bubble"));
var _Tiles = _interopRequireDefault(require("../../components/Tiles"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _standard = _interopRequireDefault(require("./standard"));
var _modular = _interopRequireDefault(require("./modular"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PlanDesignContainer = /*#__PURE__*/function (_PureComponent) {
  function PlanDesignContainer() {
    var _this;
    (0, _classCallCheck2["default"])(this, PlanDesignContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, PlanDesignContainer, [].concat(args)), _this.state = {
      classIDs: _sbUtils.helpers.sortObjByTitle(_this.props.classData),
      selectedClassID: null,
      successDialogOpen: false,
      showConfirmTypeDialog: false,
      planType: null,
      overrideModularView: false
    }, _this._selectClass = function (selectedClassID) {
      _this.setState({
        selectedClassID: selectedClassID
      });
    }, _this._toggleConfirmTypeDialog = function (type) {
      _this.setState({
        showConfirmTypeDialog: !_this.state.showConfirmTypeDialog,
        planType: type
      });
    }, _this._overrideModularView = function () {
      _this.setState({
        overrideModularView: !_this.state.overrideModularView
      });
    }, _this._submit = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(type) {
        var success;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              success = false;
              if (!(type === 'modular')) {
                _context.next = 7;
                break;
              }
              _context.next = 4;
              return _this.props.submitModuleBlueprint(_this.props.currentAccountMeta.accountID);
            case 4:
              success = _context.sent;
              _context.next = 10;
              break;
            case 7:
              _context.next = 9;
              return _this.props.submitPlanDesigns(_this.props.currentAccountMeta.accountID);
            case 9:
              success = _context.sent;
            case 10:
              if (success) {
                _this.setState({
                  successDialogOpen: true
                });
                _this.props.setSelectedSection(null);
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this._savePlanType = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var type;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            type = _this.state.planType === 'Modular Flex' ? 'Modular' : _this.state.planType;
            _this.setState({
              showConfirmTypeDialog: false
            });
            _context2.next = 4;
            return _this.props.savePlanType(type.toLowerCase());
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._closeSuccessDialog = function () {
      _this.setState({
        successDialogOpen: false
      });
    }, _this._goToNextStep = function () {
      _this.setState({
        successDialogOpen: false
      });
      _this.props.setSelectedSection("commissions");
    }, _this._goBack = function () {
      _this.setState({
        selectedClassID: null
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  /**
   * Move to the Master Application
   * @private
   */
  (0, _inherits2["default"])(PlanDesignContainer, _PureComponent);
  return (0, _createClass2["default"])(PlanDesignContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var whitelabel = this.props.whitelabel;
      var isModularFlex = this.props.currentAccountMeta.planType && this.props.currentAccountMeta.planType.toUpperCase() === 'MODULAR';

      // the account type has not been set yet so we need to do that
      if (!this.props.currentAccountMeta.planType) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
          title: _i18n["default"].t(_tokens["default"].titles.planDesign),
          subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.welcomeToPlanDesignWizard)
        }), /*#__PURE__*/_react["default"].createElement(_Tiles["default"], {
          tiles: [{
            title: _i18n["default"].t(_tokens["default"].labels.planDesign.standard),
            description: _i18n["default"].t(_tokens["default"].labels.planDesign.traditionalPlanDesign),
            step: 1,
            icon: 'Plan Designs',
            onClick: function onClick() {
              return _this2._toggleConfirmTypeDialog('Standard');
            }
          }, {
            title: _i18n["default"].t(_tokens["default"].labels.planDesign.modularFlex),
            description: _i18n["default"].t(_tokens["default"].labels.planDesign.buildTieredOfferings),
            step: 1,
            icon: 'Plan Designs',
            onClick: function onClick() {
              return _this2._toggleConfirmTypeDialog('Modular Flex');
            }
          }]
        }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
          open: this.state.showConfirmTypeDialog,
          close: function close() {
            return _this2._toggleConfirmTypeDialog(_this2.state.planType);
          },
          title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
          onSave: this._savePlanType,
          saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"]),
          customContainerStyle: {
            maxWidth: "500px"
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          margin: "10px 0 0 0"
        }, _i18n["default"].t(_tokens["default"].labels.planDesign.buttonBelowAccountType), /*#__PURE__*/_react["default"].createElement("b", null, "".concat(this.state.planType), _i18n["default"].t(_tokens["default"].labels.planDesign.cannotBeUndone))), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
          whitelabel: this.props.whitelabel,
          customImageStyle: {
            top: '50%'
          }
        })));
      }

      // the account type is standard and they have selected a class
      if (this.state.selectedClassID) {
        if (isModularFlex) {
          return /*#__PURE__*/_react["default"].createElement(_modular["default"], {
            isMasterSite: this.props.isMasterSite,
            isRevision: this.props.isRevision,
            isQuote: this.props.isQuote,
            blueprint: this.props.modularBlueprints[this.state.selectedClassID],
            classID: this.state.selectedClassID,
            selectedClass: this.props.classData[this.state.selectedClassID],
            currentAccountMeta: this.props.currentAccountMeta,
            whitelabel: whitelabel,
            saveModularBlueprint: function saveModularBlueprint(effectiveDate) {
              return _this2.props.saveModularBlueprint(_this2.state.selectedClassID, _this2.props.modularBlueprints[_this2.state.selectedClassID], effectiveDate);
            },
            saveModularBenefitInitData: this.props.saveModularBenefitInitData,
            toggleModularViewOverride: this._overrideModularView,
            saveModularField: this.props.saveModularField,
            loading: this.props.loading,
            goBack: this._goBack,
            isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor,
            language: this.props.language || 'en'
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_standard["default"], {
          isMasterSite: this.props.isMasterSite,
          isRevision: this.props.isRevision,
          isQuote: this.props.isQuote,
          selectedClassID: this.state.selectedClassID,
          selectedClass: this.props.classData[this.state.selectedClassID],
          designs: this.props.designs,
          currentAccountMeta: this.props.currentAccountMeta,
          goBack: this._goBack,
          whitelabel: whitelabel,
          createPlanDesign: this.props.createPlanDesign,
          createPlanDesignFromUpload: this.props.createPlanDesignFromUpload,
          savePlanDesign: this.props.savePlanDesign,
          clonePlanDesign: this.props.clonePlanDesign,
          savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
          savePlanDesignField: this.props.savePlanDesignField,
          revertToRevision: this.props.revertToRevision,
          getPlanDesignRevisions: this.props.getPlanDesignRevisions,
          getSinglePlanDesignRevision: this.props.getSinglePlanDesignRevision,
          overrideModularView: this.state.overrideModularView,
          toggleModularViewOverride: this._overrideModularView,
          loading: this.props.loading,
          isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor,
          language: this.props.language || 'en'
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isModularFlex ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.planDesign.modularFlexPlanDesign),
        subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.welcomeToModularFlexWizard),
        btn: this.props.isQuote && this.props.step <= 2 || this.props.isRevision && this.props.step === 0,
        btnName: _i18n["default"].t(_tokens["default"].labels.planDesign.submitModularFlexDesigns),
        btnOnClick: function btnOnClick() {
          return _this2._submit('modular');
        }
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.planDesign),
        subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.welcomeToPlanDesignWizardClass),
        btn: this.props.isQuote && this.props.step <= 2 || this.props.isRevision && this.props.step === 0,
        btnName: _i18n["default"].t(_tokens["default"].labels.planDesign.submitPlanDesigns),
        btnOnClick: function btnOnClick() {
          return _this2._submit('standard');
        }
      }), this.state.classIDs.map(function (classID) {
        var data = _this2.props.classData[classID];
        if (data.parentClassID) {
          return null;
        }
        return data.description ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          tip: data.description,
          placement: "top",
          arrow: true,
          display: "inline-block",
          key: classID
        }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
          label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(data.title),
          isSelected: true,
          onClick: function onClick() {
            return _this2._selectClass(classID);
          },
          clickable: true,
          customStyle: {
            marginLeft: "5px",
            marginRight: "5px"
          }
        })) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
          key: data.title,
          label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(data.title),
          isSelected: true,
          onClick: function onClick() {
            return _this2._selectClass(classID);
          },
          customStyle: {
            marginLeft: "5px",
            marginRight: "5px"
          }
        });
      }), isModularFlex ? /*#__PURE__*/_react["default"].createElement(_StepCompletionNotif["default"], {
        dialog: _i18n["default"].t(_tokens["default"].labels.planDesign.successfullySubmittedModularFlexPlan),
        type: "Plan Design",
        open: this.state.successDialogOpen,
        handleClose: this._closeSuccessDialog,
        handleNext: this._goToNextStep,
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }) : /*#__PURE__*/_react["default"].createElement(_StepCompletionNotif["default"], {
        dialog: _i18n["default"].t(_tokens["default"].labels.planDesign.successfullySubmittedPlanDesigns),
        type: "Plan Design",
        open: this.state.successDialogOpen,
        handleClose: this._closeSuccessDialog,
        handleNext: this._goToNextStep,
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = PlanDesignContainer;